var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { CompaniesClient, SitesClient, GetCompanySystemsQuery, ReportScheduleModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let CompanySystemsReportFilterVue = class CompanySystemsReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.statusFilterKey = 1;
        this.companies = [];
        this.sites = [];
        this.companyId = null;
        this.siteId = null;
        this.hideSiteName = false;
        this.countPerSite = false;
    }
    created() {
        this.getLookups();
    }
    mounted() {
        this.loadReportScheduleQuery();
    }
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.companyId) {
            Notifier.onWarning("Please select a company.");
            return null;
        }
        ;
        let reportQuery = new GetCompanySystemsQuery({
            timezoneOffset: moment().utcOffset(),
            companyId: this.companyId,
            siteId: this.siteId,
            hideSiteName: this.hideSiteName,
            countPerSite: this.countPerSite
        });
        return reportQuery;
    }
    exportToPdf() {
        if (this.working)
            return;
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        this.working = true;
        companyClient.downloadCompanySystemsAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            //DownloadUtil.handleFileDownload(response);
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    exportToCsv() {
        if (this.working)
            return;
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        this.working = true;
        companyClient.downloadCompanySystemsAsCsv(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery();
    }
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.companyId = query.companyId;
            this.siteId = query.siteId;
            this.hideSiteName = query.hideSiteName;
            this.countPerSite = query.countPerSite;
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    onCompanyIdChanged() {
        if (!this.working)
            this.siteId = null;
    }
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        if (!this.selectedCompanyId)
            return [];
        var filteredSites = this.sites.filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], CompanySystemsReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemsReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemsReportFilterVue.prototype, "onCompanyIdChanged", null);
CompanySystemsReportFilterVue = __decorate([
    Component({
        name: "CompanySystemsReportFilterVue",
        emits: ["schedule", "updateSchedule"]
    })
], CompanySystemsReportFilterVue);
export default CompanySystemsReportFilterVue;
